import { render, staticRenderFns } from "./AdminHeaderRight.vue?vue&type=template&id=36f5696a&"
import script from "./AdminHeaderRight.vue?vue&type=script&lang=js&"
export * from "./AdminHeaderRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports